import * as React from "react";
import { Context } from "./_context";
export const AddFillIcon = ({ size = 16, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[16] = /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Zm.75-6.25h2.75v-1.5H8.75V4.5h-1.5v2.75H4.5v1.5h2.75v2.75h1.5V8.75Z", fill: "currentColor" }));
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm-1 9H7v2h4v4h2v-4h4v-2h-4V7h-2v4Z", fill: "currentColor" }));
  return iconset[size];
};
AddFillIcon.iconId = "IMywDl";
